import {
  GET_LABTYPE,
  GET_LABTYPE_FAIL,
  GET_LABTYPE_SUCCESS,
  GET_LABTYPES,
  GET_LABTYPES_FAIL,
  GET_LABTYPES_SUCCESS,
  ADD_NEW_LABTYPE,
  ADD_LABTYPE_SUCCESS,
  ADD_LABTYPE_FAIL,
  UPDATE_LABTYPE,
  UPDATE_LABTYPE_SUCCESS,
  UPDATE_LABTYPE_FAIL,
  DELETE_LABTYPE,
  DELETE_LABTYPE_SUCCESS,
  DELETE_LABTYPE_FAIL,
  SET_STATE_LABTYPE,
  UPDATE_LABTYPE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABTYPE,
  payload: loading,
})

export const getLabTypes = ( params ) => ({
  type: GET_LABTYPES,
  payload: { params },
})

export const getLabTypesSuccess = (labtypes, totalPages, currentPage) => ({
  type: GET_LABTYPES_SUCCESS,
  payload: {labtypes:labtypes, total:totalPages, currentPage:currentPage}
})

export const getLabTypesFail = error => ({
  type: GET_LABTYPES_FAIL,
  payload: error,
})

export const addNewLabType = labtype => ({
  type: ADD_NEW_LABTYPE,
  payload: labtype,
})

export const addLabTypeSuccess = labtype => ({
  type: ADD_LABTYPE_SUCCESS,
  payload: labtype,
})  

export const addLabTypeFail = error => ({
  type: ADD_LABTYPE_FAIL,
  payload: error,
})

export const updateLabType = labType => ({
  type: UPDATE_LABTYPE,
  payload: labType,
})

export const updateLabTypeStatus = labType => ({
  type: UPDATE_LABTYPE_STATUS,
  payload: labType,
})

export const updateLabTypeSuccess = labType => ({
  type: UPDATE_LABTYPE_SUCCESS,
  payload: labType,
})

export const updateLabTypeFail = error => ({
  type: UPDATE_LABTYPE_FAIL,
  payload: error,
})

export const deleteLabType = labType => ({
  type: DELETE_LABTYPE,
  payload: labType,
})

export const deleteLabTypeSuccess = id => ({
  type: DELETE_LABTYPE_SUCCESS,
  id,
})

export const deleteLabTypeFail = error => ({
  type: DELETE_LABTYPE_FAIL,
  payload: error,
})

export const getLabType = () => ({
  type: GET_LABTYPE,
})

export const getLabTypeSuccess = labType => ({
  type: GET_LABTYPE_SUCCESS,
  payload: labType,
})

export const getLabTypeFail = error => ({
  type: GET_LABTYPE_FAIL,
  payload: error,
})
